"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newCatalogGroup = exports.CatalogGroupBuilder = exports.GroupableCatalogItemBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var builder_1 = require("../builder");
/**
 * Groupable catalog item builder
 * See {@link Builder}
 *
 * @beta
 */
var GroupableCatalogItemBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(GroupableCatalogItemBuilder, _super);
    function GroupableCatalogItemBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupableCatalogItemBuilder.prototype.groups = function (tagRefs) {
        this.item.groups = tagRefs;
        return this;
    };
    return GroupableCatalogItemBuilder;
}(builder_1.Builder));
exports.GroupableCatalogItemBuilder = GroupableCatalogItemBuilder;
/**
 * Catalog group builder
 * See {@link Builder}
 *
 * @beta
 */
var CatalogGroupBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(CatalogGroupBuilder, _super);
    function CatalogGroupBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogGroupBuilder.prototype.title = function (title) {
        this.item.title = title;
        return this;
    };
    CatalogGroupBuilder.prototype.tag = function (tagRef) {
        this.item.tag = tagRef;
        return this;
    };
    return CatalogGroupBuilder;
}(builder_1.Builder));
exports.CatalogGroupBuilder = CatalogGroupBuilder;
/**
 * Catalog group factory
 *
 * @param modifications - catalog group builder modifications to perform
 * @returns created catalog group
 * @beta
 */
exports.newCatalogGroup = function (modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(CatalogGroupBuilder, {}, modifications);
};
//# sourceMappingURL=groupFactory.js.map